import { ApiService } from "./apiService"


export const MenuService = function(){
   
    return{
        getAllItems: ()=> {
            return ApiService.get(`/api/items/navigation_items`);
        }
    }
}